import { z } from 'zod';

import { wallTypeSchema } from './WallType';

export const componentWallSchema = z.object({
  componentTag: z.string(),
  type: wallTypeSchema,
});
export type ComponentWall = z.infer<typeof componentWallSchema>;
